module.exports = __webpack_public_path__ + "static/media/komity_icon.1be1d008.png";